export default __webpack_public_path__ + "static/media/3435 spice rack C top.2f22adec.png";